export default __webpack_public_path__ + "static/assets/feea6663d2ffcec60d458836fee3e804.png";